import { useState } from 'react';
import { FaEdit } from 'react-icons/fa';

import Button from '../../../reusable/button/button.component';
import ComponentModal from '../../../reusable/component-modal/component-modal.component';
import UpdateShippingOption from './update/update-shipping-options.component';

import {
  MainContainer,
  OptionContainerRow,
  OptionDataContainer,
  OptionDataText,
  OptionDataTitle,
  OptionOptionsContainer
} from './shipping-options-display.styles';

const ShippingOptionDisplay = ({ option, getOptions, setShowDisplay }) => {
  const [showUpdate, setShowUpdate] = useState(false);

  const reload = async () => {
    await getOptions();
    setShowUpdate(false);
    setShowDisplay(false);
  }

  return (
    <MainContainer>
      <ComponentModal isOpen={showUpdate} onClose={() => setShowUpdate(false)} title="Update Shipping Option">
        <UpdateShippingOption
          option={option}
          getOptions={getOptions}
          reload={reload}
          setShowUpdate={setShowUpdate}
        />
      </ComponentModal>

      <OptionOptionsContainer>
        <FaEdit onClick={() => setShowUpdate(true)} />
      </OptionOptionsContainer>

      <OptionDataContainer>
        <OptionContainerRow>
          <OptionDataTitle>Label:</OptionDataTitle>
          <OptionDataText>{option.label}</OptionDataText>
        </OptionContainerRow>
        <OptionContainerRow>
          <OptionDataTitle>Price:</OptionDataTitle>
          <OptionDataText>${(option.price / 100).toFixed(2)}</OptionDataText>
        </OptionContainerRow>
        <OptionContainerRow>
          <OptionDataTitle>Provider:</OptionDataTitle>
          <OptionDataText>{option.ShippingProvider?.name || '—'}</OptionDataText>
        </OptionContainerRow>
        <OptionContainerRow>
          <OptionDataTitle>Type:</OptionDataTitle>
          <OptionDataText>{option.ShippingType?.name || '—'}</OptionDataText>
        </OptionContainerRow>
        <OptionContainerRow>
          <OptionDataTitle>Free Shipping Minimum:</OptionDataTitle>
          <OptionDataText>
            {option.freeShippingMinimum != null
              ? `$${(option.freeShippingMinimum / 100).toFixed(2)}`
              : '—'}
          </OptionDataText>
        </OptionContainerRow>
        <OptionContainerRow>
          <OptionDataTitle>Status:</OptionDataTitle>
          <OptionDataText>{option.active ? 'Active' : 'Inactive'}</OptionDataText>
        </OptionContainerRow>
      </OptionDataContainer>
      <OptionContainerRow>
        <Button onClick={() => setShowDisplay(false)}>Close</Button>
      </OptionContainerRow>
    </MainContainer>
  );
};

export default ShippingOptionDisplay;